import Button from '@mui/material/Button';

import { useSessionSync } from '@/auth/sessionSync';
import { LoadingScreen } from '@/components';
import { useAuth } from '@/hooks';
import { Router } from '@/router';

function App() {
  const auth = useAuth();
  useSessionSync();

  if (auth.isLoading) {
    return <LoadingScreen />;
  }

  if (!auth.isAuthenticated) {
    return <Button onClick={() => void auth.signinRedirect()}>Log in</Button>;
  }

  return <Router />;
}

export default App;
